import {HttpClient} from '@angular/common/http';
import {AfterContentChecked, Component, Inject, Input, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap';
import {EnumerationService} from '../enumeration/enumeration.service';
import {AppConfig} from '../config/app.config';
import {AuthenticationService} from '@ngx-ivengi/authentication';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/timeout';
import {SharedService} from '../shared/shared.service';
import 'rxjs/add/operator/delay';
import { UIRouter } from '@uirouter/angular';
import {DatagridService} from '../datagrid/datagrid.service';
import {ChannelService, IBulkUpdateFields} from './channel.service';
import {ToastsManager} from 'ng2-toastr';
import {ErrorMessage, NotificationService, SuccessMessage} from '@ngx-ivengi/notification';
import {CrudAction, CrudInteractionService, ErrorNotification, Notification, SuccessNotification} from '@ngx-ivengi/crud';
import {Channel} from './channel.model';

@Component({
  selector: 'app-channel-bulk-update-modal',
  templateUrl: './channel-bulk-update-modal.component.html'
})
export class ChannelBulkUpdateModalComponent {
  @Input() public data: {
    assignmentId: string[],
    channelIds: string[],
    bsModalRef: BsModalRef
  };
  properties: IBulkUpdateFields = {};

  constructor(
    @Inject(AppConfig) private appConfig,
    private enumService: EnumerationService,
    private authService: AuthenticationService,
    private http: HttpClient,
    private sharedService: SharedService,
    private datagridService: DatagridService,
    private channelService: ChannelService,
    protected router: UIRouter,
    private interactionService: CrudInteractionService,
  ) {

  }

  saveBulk( ) {
    this.channelService.bulkUpdate(this.data.channelIds, this.properties).subscribe(
      () => {
        this.data.bsModalRef.hide();
        this.interactionService.notify(
          <Notification>new SuccessNotification()
            .setEntity(<any>Channel)
            .setAction(CrudAction.UPDATE)
        );
      },
      () => {
        this.interactionService.notify(
          <Notification>new ErrorNotification()
            .setEntity(<any>Channel)
            .setAction(CrudAction.UPDATE)
        );
      },
    );
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/channel/channel-bulk-update-modal.component.ts